import React, { useEffect, useState } from "react";
import "./SavedSearchPickerModal.css";
import { globals } from "../globals";

export default function SavedSearchPickerModal({ onSelect, onCancel }) {
  const [searches, setSearches] = useState([]);

  useEffect(() => {
    fetch(globals.homepageUrl + "/php/get-saved-searches.php")
      .then(res => res.json())
      .then(data => setSearches(data.savedSearches || []));
  }, []);

  return (
    <div className="savedsearches-modal-backdrop">
      <div className="savedsearches-modal-content">
        <h3>Seleziona una ricerca salvata</h3>
        <div className="savedsearches-search-grid">
          {searches.map(search => (
            <div
              key={search.id}
              className="savedsearches-search-item"
              onClick={() => onSelect(search.id)}
            >
              <img
                src={(globals.homepageUrl + search.featured_image) || "/img/placeholder.jpg"}
                alt={search.label}
                className="savedsearches-thumb"
              />
              <div>{search.label || `ID ${search.id}`}</div>
            </div>
          ))}
        </div>
        <button className="savedsearches-button" onClick={onCancel}>Annulla</button>
      </div>
    </div>
  );
}
